(function () {
  function fmt(value, digits) {
    return value.toLocaleString('de-DE', { minimumFractionDigits: digits, maximumFractionDigits: digits });
  }

  function update(calc) {
    var input = calc.querySelector('.mg-calc__input');
    var line = calc.querySelector('.mg-calc__line');
    if (!input || !line) return;
    var qty = parseInt(input.value, 10);
    if (!qty || qty < 1) qty = 1;
    input.value = qty;
    var unit = calc.dataset.unit || 'm²';
    var one = calc.dataset.one || 'Paket';
    var many = calc.dataset.many || 'Pakete';
    var amount = qty * parseFloat(calc.dataset.pak);
    var total = qty * parseFloat(calc.dataset.price);
    line.innerHTML =
      '<strong>' + qty + ' ' + (qty === 1 ? one : many) + '</strong> = ' +
      fmt(amount, amount % 1 === 0 ? 0 : 2) + ' ' + unit + ' · ' + fmt(total, 2) + ' €';
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('[data-mg-step]') : null;
    if (!btn) return;
    var calc = btn.closest('.mg-calc');
    var input = calc && calc.querySelector('.mg-calc__input');
    if (!input) return;
    var qty = parseInt(input.value, 10) || 1;
    qty = qty + parseInt(btn.dataset.mgStep, 10);
    if (qty < 1) qty = 1;
    input.value = qty;
    update(calc);
  });

  document.addEventListener('input', function (event) {
    if (!event.target.classList || !event.target.classList.contains('mg-calc__input')) return;
    update(event.target.closest('.mg-calc'));
  });

  function sync() {
    document.querySelectorAll('.mg-calc').forEach(update);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  document.addEventListener('shopify:section:load', sync);
})();
